import React from 'react'
import QueueBarcode from '../../components/queue/QueueBarcode'

export default function QueueBarcodeScreen() {
    return (
        <div><QueueBarcode /></div>
    )
}
